import React from 'react';
import { Image, Nav, Navbar } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

export const MiniHeader = () => {
  const { t } = useTranslation();

  return (
    <Navbar variant="dark" bg="primary" sticky="top" className="p-0">
      <Nav>
        <Nav.Item>
          <Nav.Link as={NavLink} eventKey={1} to="/" aria-label={t('header.linkNames.home')} className="p-0 m-0">
            <Navbar.Brand className="p-0 m-0">
              <Image alt={t('general.appShortName')} src="/logo70x50.png" fluid className="mx-2" />
            </Navbar.Brand>
          </Nav.Link>
        </Nav.Item>
      </Nav>
    </Navbar>
  );
};
